import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';

// Then initialize them
Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);